import React from 'react'
import { Map } from '@carbon/icons-react'
import { Stack } from '@carbon/react'
import { Iframe } from './Map.styles'
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card'
import Typography from '../../../components/Basics/Typography'
import InformationContainer from '../../../components/Basics/Information.container'

/**
 * The Map's Page.
 */
const RalentiContainer = () => {

    return (
            <Stack gap={3}>
                <CardComponent width="100%" height="100%">
                    <Card $justifyContent='flex-start'>
                        <Map size={18} />
                        <Typography className='cds--type-heading-compact-01'>
                            MAPA
                        </Typography>
                    </Card>
                    <InformationContainer description="Elija un equipo en ‘Patente’ y defina el intervalo para visualizar sus movimientos recientes." />
                    <CardRow width='inherit'>
                        <Card width='100%' $padding="0">
                            <Iframe title="Monitoring map" src="https://grafana.terrestra.tech/d/a4e12673-49a4-4b08-a19a-ea360e8adc2d/mapa-de-calor-ralenti?orgId=1&refresh=2h&var-patente=TYRF47&var-intervalo=1h&from=1753348555741&to=1753370155741&kiosk" width="100%" height="100%" />
                        </Card>
                    </CardRow>
                </CardComponent>
            </Stack>
    )
}

export default RalentiContainer